import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const pluginUrl =
  (window as any).tubeOnAI?.pluginUrl ||
  (window as any).tubeOnAIElementor?.pluginUrl ||
  '/wp-content/plugins/tubeonai-wp-plugin/';
